import React from 'react';
export const useValidChildren = (children, validComponents, generateWarning) => {
    return React.Children.toArray(children).filter((child) => {
        if (!React.isValidElement(child) ||
            !validComponents.some((validComponent) => child.type === validComponent)) {
            console.warn(generateWarning?.({ validComponents, invalidComponent: child }), child);
            return false;
        }
        return true;
    });
};
//# sourceMappingURL=useValidChildren.js.map